// extracted by mini-css-extract-plugin
export default {"accommodation":"music__accommodation__2Sxwb","accommodation__block":"music__accommodation__block__2ZQyq","accommodation__frame":"music__accommodation__frame__29OaS"};